/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { TableCell, TableRow } from "@mui/material";
import React from "react";
import tableStyle from "../../theme/styles/table";
import { isEmptyObj } from "../../utils/helper";
import { style } from "./styles";

function GohonzonBatchConferral({ member, openConferralBatch }) {
  if (isEmptyObj(member) || isEmptyObj(member.handoverToMember)) {
    return null;
  }
  const { handoverToMember } = member;

  return (
    <TableRow style={tableStyle.tableRow}>
      <TableCell
        style={{
          ...style.Cell,
          color: "#043D90",
          fontWeight: "600",
          paddingLeft: "31px",
        }}
      >
        {member.id}
      </TableCell>
      <TableCell style={{ ...style.Cell, paddingLeft: "90px" }}>
        {member.numberOfApplications || "-"}
      </TableCell>
      <TableCell style={{ ...style.Cell, paddingLeft: "30px" }}>
        {handoverToMember.fullName || "-"}
        <br />
        {handoverToMember.mobileNumber}
      </TableCell>
      <TableCell
        style={{
          color: "#8C8C8C",
          display: "flex",
          // justifyContent: "center",
          marginTop: "11px",
        }}
      >
        <RemoveRedEyeOutlinedIcon
          style={style.icon}
          onClick={() => openConferralBatch(member.id)}
        />
      </TableCell>
    </TableRow>
  );
}

export default GohonzonBatchConferral;
